import {
  AppBar,
  Slide,
  Toolbar,
  Typography,
  useScrollTrigger,
} from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { getEvents } from 'app/slices/Event'
import { getAuth, getPrefectures } from 'app/slices/UI'
import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import QRCheck from './QRCheck'
import TemporaryMenu from './TemporaryMenu'

interface Props {
  window?: () => Window
  children: React.ReactElement
}
function HideOnScroll(props: Props) {
  const { children, window } = props
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  })

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  )
}
export default function AppHeader(props: Props) {
  const auth = useAppSelector((s) => s.UI.auth)
  const dispatch = useAppDispatch()
  const urlQuery = new URLSearchParams(useLocation().search)
  useEffect(() => {
    dispatch(getAuth())
    dispatch(getPrefectures())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (auth) {
      dispatch(getEvents())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth])

  return (
    <HideOnScroll {...props}>
      <AppBar>
        <Toolbar className="flex justify-between items-center">
          <Link to={`/?${urlQuery}`} className="no-underline">
            <Typography variant="h5" component="h1">
              謎解きユーザ
            </Typography>
          </Link>
          <div>
            <QRCheck />
            {auth && <TemporaryMenu auth={auth} />}
          </div>
        </Toolbar>
      </AppBar>
    </HideOnScroll>
  )
}
